import React from 'react';

export var Fragment = React.Fragment || 'div';